(function () {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("view") !== "configurator") {
    return;
  }

  const head = document.head;
  const body = document.body;
  const reactRootId = "my-react-app";

  const links = Array.from(
    document.querySelectorAll('link[rel="stylesheet"], style'),
  );
  links.forEach((link) => {
    link.remove();
  });

  const scripts = Array.from(document.querySelectorAll("script"));
  scripts.forEach((script) => {
    const src = script.getAttribute("src") || "";
    if (!src.includes("solcoders.js")) {
      script.remove();
    }
  });

  function addCss(href) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    head.appendChild(link);
  }

  function addScript(src) {
    const script = document.createElement("script");
    script.src = src;
    script.defer = true;
    head.appendChild(script);
  }

  Array.from(
    document.querySelectorAll('link[rel="stylesheet"], style'),
  ).forEach((el) => el.remove());

  Array.from(document.querySelectorAll("script")).forEach((el) => el.remove());
  const templateElement = document.querySelector("#template"); // change selector accordingly
  console.log("template",templateElement.value)
   if (templateElement && (templateElement.value === "Bathroom Mirror LED" || templateElement.value === "Bathroom Mirror With Backlighting" || templateElement.value === "Bathroom Mirror Led Configurator" || templateElement.value === "Framed Mirror Without Led Configurator" || templateElement.value === "Mirror With Frame" || templateElement.value === "Bathroom Mirror LED Configurator Vanity Ceiling Lighting With Side Panel" || templateElement.value === "Bathroom Mirror Led Configurator Washbasin Lighting Without Covers" || templateElement.value === "Bathroom Mirror Led Configurator Washbasin Ceiling Lighting With Covers" || templateElement.value === "Bathroom Mirror Led Configurator Washbasin Lighting With Covers" || templateElement.value === "Fitness Mirror 6mm Configurator Without LED")) {
     addCss("https://spiegelmax.de/cdn/shop/t/77/assets/react-XEaOuFGc.css");
     addScript("https://spiegelmax.de/cdn/shop/t/77/assets/react-XEaOuFGc.js");
   } else {
    addCss("https://spiegelmax.de/cdn/shop/t/77/assets/react-B7tD8SMF.css");
    addScript("https://spiegelmax.de/cdn/shop/t/77/assets/react-B7tD8SMF.js");
   }
  Array.from(body.children).forEach((child) => {
    if (child.id !== reactRootId) {
      child.remove();
    }
  });

  body.className = "";
})();
